import { Box, Space, SpaceVertical } from '@looker/components';
import { globalTheme } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const LayoutContainer = styled(Space)`
  height: 100%;
  align-items: stretch;
  min-width: 660px;
  gap: 0;
`;

export const LeftNav = styled(SpaceVertical)`
  width: 200px;
  border-right: 1px solid ${globalTheme.colors.outlineLight};
  padding: 16px 12px;
  flex-shrink: 0;
`;

export const NavItem = styled(Space)<{ active: boolean }>`
  padding: 12px 16px;
  border-radius: 4px;
  cursor: pointer;
  background: ${({ active }) => (active ? globalTheme.colors.primaryGradient : 'transparent')};
  color: ${({ active }) => (active ? 'white' : globalTheme.colors.textPrimary)};

  &:hover {
    background-color: ${({ active }) => (active ? globalTheme.colors.primary500 : globalTheme.colors.backgroundLight)};
  }
`;

export const ContentArea = styled(Box)`
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
`;
